package com.yogaaicoach.pages.insights

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yogaaicoach.pages.insights.data.ChartData
import com.yogaaicoach.pages.insights.data.InsightsApi
import com.yogaaicoach.pages.insights.data.InsightsStats
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class InsightsViewModel(private val api: InsightsApi) : ViewModel() {

    private val _stats = MutableStateFlow<InsightsStats?>(null)
    val stats: StateFlow<InsightsStats?> = _stats

    private val _chartData = MutableStateFlow<ChartData?>(null)
    val chartData: StateFlow<ChartData?> = _chartData

    private val _weeklySummaries = MutableStateFlow<List<WeekSummary>>(emptyList())
    internal val weeklySummaries: StateFlow<List<WeekSummary>> = _weeklySummaries

    private val _isLoaded = MutableStateFlow(false)
    val isLoaded: StateFlow<Boolean> = _isLoaded

    fun loadPage() {
        if (_isLoaded.value) return
        viewModelScope.launch {
            val response = api.getInsights()
            _stats.value = response?.stats
            _chartData.value = response?.chartData
            _weeklySummaries.value = response?.weeklySummaries?.map { it.toWeekSummary() } ?: emptyList()
            _isLoaded.value = true
        }
    }

    // jsMain uses a single long-lived insightsViewModel instance — without this, loadPage()'s
    // _isLoaded guard silently no-ops on a new login and leaves the previous user's data on screen.
    fun reset() {
        _isLoaded.value = false
        _stats.value = null
        _chartData.value = null
        _weeklySummaries.value = emptyList()
    }
}
